export function PDFViewer(props: { url: string }) {
  if (!props.url) return <p>Invalid URL</p>;

  return (
    <object
      data={`${props.url}#view=FitV`}
      type='application/pdf'
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <p>
        Your browser doesn’t support inline PDFs. Download it <a href={props.url}>here</a>.
      </p>
    </object>
  );
}
